<template>
    <ModalWrapper v-model="dialog" max-width="600">
        <template v-slot:title>
            {{ $t('destination') }}
        </template>
        <template v-slot:content>
            <city-autocomplete v-model="city" label="location" outlined show-details />
            <daterange
                :start-date-label="$t('date_from')"
                :end-date-label="$t('date_to')"
                :_start-date="destination.dateFrom"
                :_end-date="destination.dateTo"
                same-date
                @change-start-date="destination.dateFrom = $event"
                @change-end-date="destination.dateTo = $event"
            />
        </template>
        <template v-slot:btns>
            <v-btn variant="flat" :disabled="!city || loading" :loading="loading" @click="save">
                {{ $t('save') }}
            </v-btn>
        </template>
    </ModalWrapper>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'
    import CityAutocomplete from '@/components/search/forms/CityAutocomplete.vue'
    import Daterange from '~/components/search/forms/Daterange.vue'
    import {clone} from '~/utils/helpers'

    const blankDestination = () => ({
        id: null,
        cityId: null,
        dateFrom: null,
        dateTo: null,
        serviceIds: [],
    })

    @Component({
        components: {
            Daterange,
            CityAutocomplete,
        },
    })
    export class OrderDestinationModal extends Vue {
        @Prop({required: true, type: Object}) order
        @Prop({required: true, type: Array}) destinations
        @Prop({required: true, type: Array}) destinationLocations

        dialog = false
        destination = blankDestination()
        city = null
        loading = false

        async save() {
            try {
                this.loading = true
                this.destination.cityId = this.city.id
                if (this.destination.id) {
                    const destination = await this.$api.orderDestinations.put(this.order.orderId, this.destination)
                    if (!this.destinationLocations.find(({id}) => id === this.city.id)) {
                        this.destinationLocations.push(this.city)
                    }
                    this.destinations[this.destinations.findIndex(({id}) => id === destination.id)] = destination
                } else {
                    const destination = await this.$api.orderDestinations.post(this.order.orderId, this.destination)
                    this.destinationLocations.push(this.city)
                    this.destinations.push(destination)
                }
                this.$toast.success(this.$t('success_message.saved_successfully'))
                this.dialog = false
            } catch (e) {
                console.error(e)
                this.$toast.error(this.$t('error_message.save_error'))
            } finally {
                this.loading = false
            }
        }

        open(destination, destinationLocation) {
            this.destination = destination
                ? {
                      ...clone(destination),
                      dateFrom: new Date(destination.dateFrom),
                      dateTo: new Date(destination.dateTo),
                  }
                : blankDestination()
            this.city = destinationLocation
            this.dialog = true
        }
    }

    export default OrderDestinationModal
</script>
